( function () {
    'use strict';
    /**
     * @namespace
     * @property {HtmlElements} selectors
     * @property {string} translations
     * @property {object} data
     * @property {boolean} suggestCorrection
     * @property {function} suggestIsAboutToFire
     * @property {boolean} filters
     */
    master.workshopSearch = {
        selectors: {
            typeaheadContainer: jQuery( '.js-module-workshop-lookup' ),
            searchInput: jQuery( '.js-module-workshop-lookup-input' )
        },
        translations: {
            seeAllWorkshops: master.translations.base.data( 'see-all-workshops' ),
            typoSuggestionText: master.translations.base.data( 'typo-suggestion' ),
            noResultSeeAllSorkshops: master.translations.base.data( 'no-result-see-all-workshops' )
        },
        data: {},
        suggestCorrection: false,
        suggestIsAboutToFire: undefined,
        filters: {
            booking: jQuery( 'body' ).data( 'area' ) === 'booking' ? true : false,
            webshop: jQuery( 'body' ).data( 'area' ) === 'webshop' ? true : false
        },
        /** @function */
        /**
         * Load up typeahead and parse data from sessionStorage
         */
        load: function () {
            var jThis = this;
            this.selectors.searchInput.typeahead( {
                menu: '<ul class="typeahead nav dropdown-menu js-e-typeahead-dropdown"></ul>',
                items: master.settings.workshopSearch.maxItems,
                minLength: master.settings.workshopSearch.minLength,
                source: function ( query, process ) {
                    if ( jThis.suggestIsAboutToFire ) {
                        clearTimeout( jThis.suggestIsAboutToFire );
                    }
                    master.workshopSearch.data.workshopsFound = [];
                    master.workshopSearch.map = {};
                    var data = JSON.parse( sessionStorage.getItem( 'UserManagementAddresses' ) );
                    jQuery.each( data, function ( i, workshop ) {
                        if ( workshop.Name !== '' && workshop.CustomerNumber !== '' && ( workshop.Permissions.WebshopEnabled === true || workshop.Permissions.BookingEnabled === true ) ) {
                            if ( master.workshopSearch.filters.booking === true ) {
                                if ( workshop.Permissions.BookingEnabled === true ) {
                                    master.workshopSearch.map[ workshop.Name ] = workshop;
                                    master.workshopSearch.data.workshopsFound.push( workshop.Name );
                                }
                            }
                            /*
                            else if ( master.workshopSearch.filters.webshop === true ) {
                                if ( workshop.Permissions.WebshopEnabled === true ) {
                                    master.workshopSearch.map[ workshop.Name ] = workshop;
                                    master.workshopSearch.data.workshopsFound.push( workshop.Name );
                                }
                            }
                            */
                            else {
                                master.workshopSearch.map[ workshop.Name ] = workshop;
                                master.workshopSearch.data.workshopsFound.push( workshop.Name );
                            }
                        }
                    } );
                    jThis.suggestIsAboutToFire = setTimeout( function () {
                        process( master.workshopSearch.data.workshopsFound );
                    }, 250 );
                },
                sorter: function ( items ) {
                    return items;
                },
                highlighter: function ( item ) {
                    var itemMap = master.workshopSearch.map[ item ],
                        hasPermission = '',
                        hasPermissionText = '';
                    if ( itemMap ) {
                        if ( itemMap.Distance ) {
                            item += ' <small class="module-workshop-lookup-workshop-distance"> ' + parseInt( itemMap.Distance ) + ' km</small> ';
                        }
                        if ( itemMap.Permissions ) {
                            /*
                            if ( itemMap.Permissions.BookingEnabled === true && itemMap.Permissions.WebshopEnabled === true ) {
                                hasPermission = 'webshop-booking';
                                hasPermissionText = 'Webshop / Book tid online';
                            }
                            */
                            if ( itemMap.Permissions.BookingEnabled === true /*&& itemMap.Permissions.WebshopEnabled === false*/ ) {
                                hasPermission = 'booking';
                                hasPermissionText = 'Book tid online';
                            }
                            /*
                            if ( itemMap.Permissions.BookingEnabled === false && itemMap.Permissions.WebshopEnabled === true ) {
                                hasPermission = 'webshop';
                                hasPermissionText = 'Webshop';
                            }
                            */
                            /*data-webshop="' + itemMap.Permissions.WebshopEnabled + '"*/
                            item += '<span class="module-workshop-lookup-workshop-permissions module-workshop-lookup-workshop-permissions-badge-' + hasPermission + '" data-booking="' + itemMap.Permissions.BookingEnabled + '" data-permission="' + hasPermission + '">' + hasPermissionText + '</span>';
                        }
                    }
                    return item;
                },
                matcher: function ( item ) {
                    var thisQuery = this.query.trim().toLowerCase(),
                        itemName = master.workshopSearch.map[ item ].Name.trim().toLowerCase(),
                        itemZipcode = master.workshopSearch.map[ item ].Zipcode.trim().toLowerCase(),
                        itemCity = master.workshopSearch.map[ item ].City.trim().toLowerCase();
                    var thisQueryReplaceAa = thisQuery.replace("aa", "å");
                    var thisqueryReplaceDanishAa = thisQuery.replace("å", "aa");
                    return itemName.indexOf(thisQuery) >= 0 || itemZipcode.indexOf(thisQuery) >= 0 || itemCity.indexOf(thisQuery) >= 0 ||
                        itemName.indexOf(thisQueryReplaceAa) >= 0 || itemZipcode.indexOf(thisQueryReplaceAa) >= 0 || itemCity.indexOf(thisQueryReplaceAa) >= 0 ||
                        itemName.indexOf(thisqueryReplaceDanishAa) >= 0 || itemZipcode.indexOf(thisqueryReplaceDanishAa) >= 0 || itemCity.indexOf(thisqueryReplaceDanishAa) >= 0;
                },
                updater: function ( item ) {
                    if ( item !== undefined && item !== master.workshopSearch.translations.seeAllWorkshops && item !== master.workshopSearch.translations.noResultSeeAllSorkshops && item.indexOf( master.workshopSearch.translations.typoSuggestionText ) === -1 ) {
                        var workshopdata = master.workshopSearch.map[ item ];
                        var jCurrentWorkshopID = jQuery( 'meta[name="workshopID"]' );
                        if ( jCurrentWorkshopID.length ) {
                            if ( parseInt( jCurrentWorkshopID.attr( 'content' ) ) !== parseInt( workshopdata.CustomerNumber ) ) {
                                master.checkout.cart.commands.emptyCart();
                                master.workshopSearch.setWorkshopData( false, workshopdata.Name, workshopdata.Address, workshopdata.Zipcode, workshopdata.City, workshopdata.Phone, workshopdata.CustomerNumber, false, workshopdata.DepartmentId );
                                return master.workshopSearch.map[ item ].Name;
                            }
                            else {
                                master.workshopSearch.setWorkshopData( false, workshopdata.Name, workshopdata.Address, workshopdata.Zipcode, workshopdata.City, workshopdata.Phone, workshopdata.CustomerNumber, false, workshopdata.DepartmentId );
                                return master.workshopSearch.map[ item ].Name;
                            }
                        }
                        else {
                            master.workshopSearch.setWorkshopData( false, workshopdata.Name, workshopdata.Address, workshopdata.Zipcode, workshopdata.City, workshopdata.Phone, workshopdata.CustomerNumber, false, workshopdata.DepartmentId );
                            return master.workshopSearch.map[ item ].Name;
                        }
                    }
                    else {
                        if ( item !== undefined ) {
                            if ( item.indexOf( master.workshopSearch.translations.typoSuggestionText ) > -1 ) {
                                item = jQuery( '.js-typo-suggestion' ).data( 'correction' );
                                return item;
                            }
                            else {
                                location.href = jQuery( '.js-module-workshop-lookup-all-workshops-button' ).attr( 'href' );
                            }
                        }
                    }
                }
            } );
        },
        /**
         * @namespace
         */
        callback: {
            actions: {
                addToCart: function ( arg ) {
                    master.checkout.cart.commands.addToCart( arg, 'reload', '?cartcmdadd=true' );
                }
            },
            init: function () {
                this.bindEvents();
            },
            bindEvents: function () {
                var that = this;
                jQuery( '.js-user-info-and-search-workshop-lookup-toggle' ).on( 'click', function () {
                    if ( jQuery( this ).attr( 'class' ).indexOf( 'js-user-info-and-search-workshop-lookup-callback' ) > -1 ) {
                        var callbackTypeArr = jQuery( this ).attr( 'class' ).split( ' ' );
                        that.filter( callbackTypeArr, jQuery( this ) );
                    }
                } );
                jQuery( window ).on( 'beforeunload', function () {
                    sessionStorage.removeItem( 'workshopSelectCallback' );
                } );
            },
            filter: function ( callbackTypeArr, jThis ) {
                for ( var i = 0; i < callbackTypeArr.length; i++ ) {
                    if ( callbackTypeArr[ i ].indexOf( 'js-user-info-and-search-workshop-lookup-callback' ) > -1 ) {
                        var obj = {
                            action: callbackTypeArr[ i ].split( '_' )[ 1 ],
                            productID: jThis.closest( 'form' ).find( 'input[name="ProductID"]' ).val()
                        };
                        sessionStorage.workshopSelectCallback = JSON.stringify( obj );
                    }
                }
            },
            check: function () {
                if ( sessionStorage.workshopSelectCallback ) {
                    var callback = JSON.parse( sessionStorage.workshopSelectCallback );
                    this.actions[ callback.action ]( callback.productID );
                }
                else {
                    location.reload();
                }
            }
        },
        /** @function */
        /**
         * Set selected workshop and post to server
         * @param {boolean} gmQuery
         * @param {string} jAddress
         * @param {string} jZipcode
         * @param {string} jCity
         * @param {string} jPhone
         * @param {string} jId
         * @param {boolean} local
         * @param {string} jDepartment
         * @async
         */
        setWorkshopData: function ( gmQuery, jName, jAddress, jZipcode, jCity, jPhone, jId, local, jDepartment ) {
            var jThis = this;
            if ( gmQuery ) {
                jQuery.each( JSON.parse( master.store.session.userManagementAddresses ), function ( index, val ) {
                    if ( val.Zipcode === jZipcode ) {
                        jAddress = val.Address;
                        jCity = val.City;
                    }
                } );
            }
            jQuery( 'input[name="EcomOrderDeliveryName"]' ).val( jName );
            jQuery( 'input[name="EcomOrderDeliveryAddress"]' ).val( jAddress );
            jQuery( 'input[name="EcomOrderDeliveryZip"]' ).val( jZipcode );
            jQuery( 'input[name="EcomOrderDeliveryCity"]' ).val( jCity );
            jQuery( 'input[name="EcomOrderDeliveryPhone"]' ).val( jPhone );
            jQuery( 'input[name="WorkshopID"]' ).val( jId );
            jQuery( 'input[name="DepartmentId"]' ).val( jDepartment );
            jQuery( '.js-workshop-user-id' ).val( jId );
            jQuery( '.js-workshop-user-name' ).val( jName );
            master.ecom.checkStock( 'cart', jDepartment );
            var localWorkshop = {
                'Name': jName,
                'Address': jAddress,
                'Zipcode': jZipcode,
                'City': jCity,
                'Phone': jPhone,
                'CustomerNumber': jId,
                'DepartmentId': jDepartment
            };
            jThis.selectors.searchInput.trigger( 'change' ).parent().addClass( 'module-workshop-lookup--selected' );
            master.store.session.set( 'myWorkshop', JSON.stringify( localWorkshop ) );
            jQuery.ajax( {
                url: master.data.workshops.endpoint,
                type: 'POST',
                data: {
                    action: master.data.workshops.actions.set,
                    workshop: jId
                },
            } ).done( function ( data ) {
                if ( data.Data.Success === true ) {
                    master.store.session.unset( 'workshop-return-url' );
                    master.store.session.set( 'workshopSelected', jName );
                    var searchType = jQuery( '.master-service-grid-workshop-lookup' ).length ? 'Søgeboks i indhold' : 'Søgeboks';
                    master.tracking.toTrack( {
                        'fn': 'workshop',
                        args: [
                            jName,
                            location.href,
                            searchType
                        ]
                    } );
                    //master.tracking.workshop( jName, location.href, searchType );
                    jQuery.cookie( 'e-w-selected', 'false' );
                    master.workshopSearch.callback.check();
                }
                else {
                    alert( data.Data.Status );
                }
            } );
        },
        /** @function */
        /**
         * Find city based on zipcodes or city
         * @return {function}
         */
        findCity: function () {
            var jResult = false,
                q = this.selectors.searchInput.val(),
                masterZipcodes = JSON.parse( localStorage.getItem( 'master-zipcodes' ) ); 
            for ( var i = 0; i < masterZipcodes.length; i++ ) {
                if ( !jResult ) {
                    if ( jQuery.isNumeric( q ) ) {
                        if ( ( parseInt( q ) === parseInt( masterZipcodes[ i ].Zipcode ) || ( q.toLowerCase() === masterZipcodes[ i ].City.toLowerCase() ) ) ) {
                            jResult = {
                                'City': masterZipcodes[ i ].City,
                                'Zipcode': masterZipcodes[ i ].Zipcode,
                                'Latitude': masterZipcodes[ i ].Latitude,
                                'Longitude': masterZipcodes[ i ].Longitude
                            };
                        }
                    }
                    else {
                        if ( q.toLowerCase() === masterZipcodes[ i ].City.toLowerCase() ) {
                            jResult = {
                                'City': masterZipcodes[ i ].City,
                                'Zipcode': masterZipcodes[ i ].Zipcode,
                                'Latitude': masterZipcodes[ i ].Latitude,
                                'Longitude': masterZipcodes[ i ].Longitude
                            };
                        }
                    }
                }
            }
            return this.setFoundWorkshop( jResult, q );
        },
        /** @function */
        /**
         * Get nearest cities and return
         * @param {object} jResult
         * @param {string} q
         * @return {object}
         */
        setFoundWorkshop: function ( jResult, q ) {
            var jThis = this,
                returnArr = {};
            if ( jResult ) {
                master.workshopSearch.suggestCorrection = false;
                //returnArr = jThis.calcClosestCity.nearest( jResult );
                return returnArr;
            }
            else {
                var typoSuggestion = master.utils.spellCheck.matcher( q );
                if ( typoSuggestion !== undefined && typoSuggestion !== false ) {
                    master.workshopSearch.suggestCorrection = true;
                    var returnTypo = [ master.workshopSearch.translations.typoSuggestionText + '<strong>' + typoSuggestion + '</strong> <span class="js-typo-suggestion" data-correction="' + typoSuggestion + '"> </span>?' ];
                    return returnTypo;
                }
                else {
                    master.workshopSearch.suggestCorrection = false;
                    var returnNoResults = [ master.workshopSearch.translations.noResultSeeAllSorkshops ];
                    return returnNoResults;
                }
            }
            /** @function */
            /**
             * Event handler
             */
        },
        keyHandler: function () {
            this.selectors.searchInput.on( 'click', function () {
                master.workshopSearch.selectors.searchInput = jQuery( this );
                master.workshopSearch.selectors.typeaheadContainer = jQuery( this ).parent( '.js-module-workshop-lookup' );
                jQuery( this ).parent().removeClass( 'module-workshop-lookup--selected' );
                jQuery( this ).val( '' );
            } );
            this.selectors.searchInput.on( 'blur', function () {
                if ( jQuery( this ).val() ) {
                    jQuery( this ).parent().addClass( 'module-workshop-lookup--selected' );
                }
            } );
            this.selectors.searchInput.on( 'change', function () {
                if ( master.workshopSearch.suggestCorrection ) {
                    master.workshopSearch.selectors.searchInput.trigger( 'keyup' );
                }
            } );
            master.workshopSearch.selectors.typeaheadContainer.on( 'keydown', function ( event ) {
                var keyPressed = event.which;
                if ( ( keyPressed === 13 || keyPressed === 9 ) && master.workshopSearch.selectors.typeaheadContainer.find( '.js-e-typeahead-dropdown' ).is( ':visible' ) === true ) {
                    event.preventDefault();
                    master.workshopSearch.selectors.typeaheadContainer.find( '.js-e-typeahead-dropdown' ).find( 'li.active' ).trigger( 'click' );
                }
            } );
        },
        /** @function */
        /**
         * Extend typeahead process
         */
        extend: function () {
            var jThis = this;
            jQuery.fn.typeahead.Constructor.prototype.process = function ( items ) {
                var that = this,
                    matchFound = false;
                items = jQuery.grep( items, function ( item ) {
                    return that.matcher( item );
                } );
                items = this.sorter( items );
                if ( !items.length ) {
                    items = jThis.findCity();
                    //return undefined;
                }
                else {
                    matchFound = true;
                }
                if ( matchFound ) {
                    return this.render( items.slice( 0, this.options.items ) ).show();
                }
                else {
                    var returnItem = [];
                    if ( items !== undefined && items.length !== 1 ) {
                        /*
                        if ( items.match ) {
                            returnItem.push( items.match.Name );
                            master.workshopSearch.map[ items.match.Name ].Distance = items.match.Distance;
                        }
                        */
                        jQuery.each( items, function ( index, workshop ) {
                            returnItem.push( workshop.Name );
                            master.workshopSearch.map[ workshop.Name ].Distance = workshop.Distance;
                        } );
                        /*
                        if ( items.second ) {
                            returnItem.push( items.second.Name );
                            master.workshopSearch.map[ items.second.Name ].Distance = items.second.Distance;
                        }
                        if ( items.third ) {
                            returnItem.push( items.third.Name );
                            master.workshopSearch.map[ items.third.Name ].Distance = items.third.Distance;
                        }
                        */
                        returnItem.push( master.workshopSearch.translations.seeAllWorkshops );
                    }
                    else {
                        returnItem = items;
                    }
                    master.workshopSearch.updateWorkshopDistance( items );
                    return this.render( returnItem.slice( 0, this.options.items ) ).show();
                }
            };
            jThis.selectors.searchInput.on( 'focus', jThis.selectors.searchInput.typeahead.bind( jThis.selectors.searchInput, 'lookup' ) );
        },
        /** @function */
        /**
         * Find closest cities
         */
        calcClosestCity: {
            deg2Rad: function ( deg ) {
                return deg * Math.PI / 180;
            },
            pythagorasEquirectangular: function ( lat1, lon1, lat2, lon2 ) {
                lat1 = this.deg2Rad( lat1 );
                lat2 = this.deg2Rad( lat2 );
                lon1 = this.deg2Rad( lon1 );
                lon2 = this.deg2Rad( lon2 );
                var R = 6371; // km
                var x = ( lon2 - lon1 ) * Math.cos( ( lat1 + lat2 ) / 2 );
                var y = ( lat2 - lat1 );
                var d = Math.sqrt( x * x + y * y ) * R;
                return d;
            },
            getRegion: function ( zip ) {
                if ( zip > 4999 ) {
                    return 1;
                }
                else if ( zip <= 4999 ) {
                    return 2;
                }
            },
            checkCond: function ( index, userManagementAddressesData ) {
                if ( master.workshopSearch.filters.booking === true ) {
                    return userManagementAddressesData[ index ].Name !== '' && userManagementAddressesData[ index ].CustomerNumber !== '' && ( userManagementAddressesData[ index ].Permissions.BookingEnabled === true );
                }
                /*
                else if ( master.workshopSearch.filters.webshop === true ) {
                    return userManagementAddressesData[ index ].Name !== '' && userManagementAddressesData[ index ].CustomerNumber !== '' && ( userManagementAddressesData[ index ].Permissions.WebshopEnabled === true );
                }
                */
                else {
                    return userManagementAddressesData[ index ].Name !== '' && userManagementAddressesData[ index ].CustomerNumber !== '' && ( userManagementAddressesData[ index ].Permissions.BookingEnabled === true || userManagementAddressesData[ index ].Permissions.WebshopEnabled === true );
                }
            },
            nearest: function ( jResult ) {
                var mindif = 99999,
                    returnArr = {},
                    zipArr = [],
                    region = this.getRegion( parseInt( jResult.Zipcode ) ),
                    excludeByRegion = true,
                    userManagementAddressesData = JSON.parse( sessionStorage.getItem( 'UserManagementAddresses' ) );
                for ( var index = 0; index < userManagementAddressesData.length; ++index ) {
                    if ( excludeByRegion ) {
                        if ( region === 1 && parseInt( userManagementAddressesData[ index ].Zipcode ) > 4999 ) {
                            if ( this.checkCond( index, userManagementAddressesData ) ) {
                                zipArr[ index ] = {
                                    'Zipcode': parseInt( userManagementAddressesData[ index ].Zipcode ),
                                    'Name': userManagementAddressesData[ index ].Name,
                                    'City': userManagementAddressesData[ index ].City,
                                    'CustomerNumber': userManagementAddressesData[ index ].CustomerNumber,
                                    'Distance': this.pythagorasEquirectangular( jResult.Latitude, jResult.Longitude, userManagementAddressesData[ index ].Latitude, userManagementAddressesData[ index ].Longitude )
                                };
                            }
                        }
                        else if ( region === 2 && parseInt( userManagementAddressesData[ index ].Zipcode ) <= 4999 ) {
                            if ( this.checkCond( index, userManagementAddressesData ) ) {
                                zipArr[ index ] = {
                                    'Zipcode': parseInt( userManagementAddressesData[ index ].Zipcode ),
                                    'Name': userManagementAddressesData[ index ].Name,
                                    'City': userManagementAddressesData[ index ].City,
                                    'CustomerNumber': userManagementAddressesData[ index ].CustomerNumber,
                                    'Distance': this.pythagorasEquirectangular( jResult.Latitude, jResult.Longitude, userManagementAddressesData[ index ].Latitude, userManagementAddressesData[ index ].Longitude )
                                };
                            }
                        }
                    }
                    else {
                        if ( this.checkCond( index, userManagementAddressesData ) ) {
                            zipArr[ index ] = {
                                'Zipcode': parseInt( userManagementAddressesData[ index ].Zipcode ),
                                'Name': userManagementAddressesData[ index ].Name,
                                'City': userManagementAddressesData[ index ].City,
                                'CustomerNumber': userManagementAddressesData[ index ].CustomerNumber,
                                'Distance': this.pythagorasEquirectangular( jResult.Latitude, jResult.Longitude, userManagementAddressesData[ index ].Latitude, userManagementAddressesData[ index ].Longitude )
                            };
                        }
                    }
                    var dif = this.pythagorasEquirectangular( jResult.Latitude, jResult.Longitude, userManagementAddressesData[ index ].Latitude, userManagementAddressesData[ index ].Longitude );
                    if ( dif < mindif ) {
                        if ( excludeByRegion ) {
                            if ( region === 1 && parseInt( userManagementAddressesData[ index ].Zipcode ) > 4999 ) {
                                if ( this.checkCond( index, userManagementAddressesData ) ) {
                                    returnArr.match = {
                                        'Name': userManagementAddressesData[ index ].Name,
                                        'City': userManagementAddressesData[ index ].City,
                                        'Zipcode': userManagementAddressesData[ index ].Zipcode,
                                        'CustomerNumber': userManagementAddressesData[ index ].CustomerNumber,
                                        'Distance': dif
                                    };
                                    mindif = dif;
                                }
                            }
                            else if ( region === 2 && parseInt( userManagementAddressesData[ index ].Zipcode ) <= 4999 ) {
                                if ( this.checkCond( index, userManagementAddressesData ) ) {
                                    returnArr.match = {
                                        'Name': userManagementAddressesData[ index ].Name,
                                        'City': userManagementAddressesData[ index ].City,
                                        'Zipcode': userManagementAddressesData[ index ].Zipcode,
                                        'CustomerNumber': userManagementAddressesData[ index ].CustomerNumber,
                                        'Distance': dif
                                    };
                                    mindif = dif;
                                }
                            }
                        }
                        else {
                            if ( this.checkCond( index, userManagementAddressesData ) ) {
                                returnArr.match = {
                                    'Name': userManagementAddressesData[ index ].Name,
                                    'City': userManagementAddressesData[ index ].City,
                                    'Zipcode': userManagementAddressesData[ index ].Zipcode,
                                    'CustomerNumber': userManagementAddressesData[ index ].CustomerNumber,
                                    'Distance': dif
                                };
                                mindif = dif;
                            }
                        }
                    }
                }
                zipArr = zipArr.sort( function ( a, b ) {
                    a = a.Distance;
                    b = b.Distance;
                    return a - b;
                } );
                if ( zipArr.length ) {
                    for ( var i = 1; i < 10; i++ ) {
                        if ( zipArr[ i ] !== undefined ) {
                            returnArr[ 'workshop' + i ] = {
                                'Name': zipArr[ i ].Name,
                                'City': zipArr[ i ].City,
                                'Zipcode': zipArr[ i ].Zipcode,
                                'CustomerNumber': zipArr[ i ].CustomerNumber,
                                'Distance': zipArr[ i ].Distance
                            };
                        }
                    }
                    /*
                    returnArr.second = {
                        'Name': zipArr[ 1 ].Name,
                        'City': zipArr[ 1 ].City,
                        'Zipcode': zipArr[ 1 ].Zipcode,
                        'Distance': zipArr[ 1 ].Distance
                    };
                    returnArr.third = {
                        'Name': zipArr[ 2 ].Name,
                        'City': zipArr[ 2 ].City,
                        'Zipcode': zipArr[ 2 ].Zipcode,
                        'Distance': zipArr[ 2 ].Distance
                    };
                    */
                }
                return returnArr;
            }
        },
        /** @function */
        /**
         * Update distance and sort workshops
         * @param {object} items
         */
        updateWorkshopDistance: function ( items ) {
            var dealerQArr = [];
            jQuery.each( items, function ( index, workshop ) {
                dealerQArr.push( {
                    Name: workshop.Name,
                    City: workshop.City,
                    Zipcode: workshop.Zipcode,
                    CustomerNumber: workshop.CustomerNumber,
                    Distance: workshop.Distance
                } );
            } );
            dealerQArr = dealerQArr.sort( function ( a, b ) {
                a = a.Distance;
                b = b.Distance;
                return a - b;
            } );
            sessionStorage.setItem( 'dealerq-data', JSON.stringify( dealerQArr ) );
        },
        /** @function */
        /**
         * Clear searchbox
         */
        checkForValue: function () {
            this.selectors.searchInput.on( 'keydown', function () {
                jQuery( this ).parent().removeClass( 'workshop-selected' );
            } );
        },
        /** @function */
        /**
         * Toggle dropdown for workshop search in menu
         */
        toggleDropdown: function () {
            var jPanel = jQuery( '.js-user-info-and-search-workshop-lookup-panel' ),
                jOverlay = jQuery( '.js-user-info-and-search-workshop-lookup-overlay' );
            jQuery( '.js-user-info-and-search-workshop-lookup-toggle' ).on( 'click', function () {
                jPanel.toggleClass( 'disabled enabled' );
                jOverlay.toggle();
                co3.util.scroll.toElement( jPanel, 0, true, true );
                if ( !jPanel.find( '.js-module-workshop-lookup-input' ).val() ) {
                    setTimeout( function () {
                        jPanel.find( '.js-module-workshop-lookup-input' ).focus();
                    }, 500 );
                }
            } );
            jQuery( '.js-user-info-and-search-workshop-lookup-track-bar' ).on( 'click', function () {
                master.tracking.toTrack( {
                    'fn': 'workshop',
                    args: [
                        null,
                        location.href, 'Klik på vælg afhentningsværksted'
                    ]
                } );
            } );
            jOverlay.on( 'click', function () {
                jPanel.toggleClass( 'disabled enabled' );
                jOverlay.toggle();
            } );
        },
        lookupZipcodeInForm: {
            handler: function () {
                var that = this;
                jQuery( document ).on( 'keyup', 'input.js-lookup-zipcode', function () {
                    if ( jQuery( this ).val().length > 2 ) {
                        var jCityInput = jQuery( 'input.js-lookup-city' ),
                            cityFound = that.search( jQuery( this ).val() );
                        jCityInput.val( cityFound );
                    }
                } );
            },
            search: function ( jValue ) {
                if ( jQuery( 'html' ).attr( 'lang' ) === 'da' ) {
                    var masterZipcodes = JSON.parse( master.store.local.zipcodes );
                    for ( var i = 0; i < masterZipcodes.length; i++ ) {
                        if ( parseInt( masterZipcodes[ i ].Zipcode ) === parseInt( jValue ) ) {
                            return masterZipcodes[ i ].City;
                        }
                    }
                }
                else {
                    return '';
                }
            }
        },
        /** @function */
        /**
         * Go to map and remember where you came from
         */
        seeAllworkshops: function () {
            jQuery( '.js-module-workshop-lookup' ).on( 'click', '.js-module-workshop-lookup-all-workshops-button', function ( event ) {
                event.preventDefault();
                var returnUrl = location.href,
                    gotoUrl = jQuery( this ).attr( 'href' ) /* + jQuery('.js-module-workshop-lookup-input').val() ? '?workshopquery=' + jQuery('.js-module-workshop-lookup-input').val() : ''*/ ;
                sessionStorage.workshopReturnUrl = returnUrl;
                location.href = gotoUrl;
            } );
        },
        /** @function */
        /**
         * Reset workshop
         */
        clear: function () {
            jQuery( '.js-workshop-reset' ).on( 'click', function () {
                jQuery.post( master.data.workshops.endpoint, {
                    action: master.data.workshops.actions.clear
                }, function () {
                    location.reload();
                } );
            } );
        },
        init: function () {
            this.keyHandler();
            this.toggleDropdown();
            this.load();
            this.checkForValue();
            this.extend();
            this.seeAllworkshops();
            this.lookupZipcodeInForm.handler();
            this.clear();
            this.callback.init();
        }
    };
}() );
